import MainNavigator from './Navigators/MainNavigator';

function App() {
  return (
    <MainNavigator />
  );
}

export default App;
